module.exports = __webpack_public_path__ + "front/img/65.3c45975c.jpg";